import * as React from 'react';
import styles from './Burger.module.css';
import classNames from 'classnames';
export default function Burger(_a) {
    var _b, _c, _d;
    var on = _a.on, onClick = _a.onClick, style = _a.style;
    return (React.createElement("div", { className: styles.container, onClick: onClick, style: style },
        React.createElement("div", { className: classNames(styles.line, (_b = {}, _b[styles.openTop] = on, _b)) }),
        React.createElement("div", { className: classNames(styles.line, (_c = {}, _c[styles.openMiddle] = on, _c)) }),
        React.createElement("div", { className: classNames(styles.line, (_d = {}, _d[styles.openBottom] = on, _d)) })));
}
